<div class="sizing-card" [class.active]="active" [class.completed]="completed" [class.failed]="failed" [class.in-progress]="sizingStatus === SizingStatus.IN_PROGRESS">
    <div class="status-row">
        <mat-icon *ngIf="completed" svgIcon="circle_tick" class="status-icon completed-icon"></mat-icon>
        <mat-icon *ngIf="failed" svgIcon="report_problem" class="icon-md-2 failed-icon"></mat-icon>
        <mat-progress-spinner *ngIf="sizingStatus === SizingStatus.IN_PROGRESS" mode="indeterminate" diameter="18" strokeWidth="1" class="status-loader"></mat-progress-spinner>

        <mat-icon *ngIf="active && sizingStatus === SizingStatus.NOT_STARTED" svgIcon="circle_dot" class="status-icon active-icon">
        </mat-icon>

        <mat-icon *ngIf="!active && !completed && sizingStatus !== SizingStatus.IN_PROGRESS" svgIcon="circle_dot" class="status-icon inactive-icon">
        </mat-icon>
        <span [class.text-disabled]="!active && !completed && sizingStatus !== SizingStatus.IN_PROGRESS" [class.text-orange]="sizingStatus === SizingStatus.IN_PROGRESS" [class.text-red]="sizingStatus === SizingStatus.FAILED" class="status-text fs-16 fw-500">Sizing</span>
    </div>
    <div>
        <span class="text-orange fs-12 fw-400" *ngIf="sizingStatus === SizingStatus.IN_PROGRESS">{{'SIZING.SIZING_PROGRESS' | transloco}}</span>
        <span class="text-red fs-12 fw-400" *ngIf="sizingStatus === SizingStatus.FAILED">{{'SIZING.SIZING_FAILED' | transloco}}</span>
        <div *ngIf="sizingStatus === SizingStatus.COMPLETED" class="created-row">
            <span class="label fs-12 fw-400">{{'BLUEPRINT_SUMMARY.CREATED' | transloco}}:</span>
            <ng-container *ngIf="!isDateLoading; else loader">
                <span class="value fs-12 fw-400">{{ formattedDate }}</span>
            </ng-container>
            <ng-template #loader>
                <div class="skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '18px', width: '120px' }"></ngx-skeleton-loader>
                </div>
            </ng-template>
            <span class="vertical-indicator"></span>
            <mat-icon class="account-circle" svgIcon="account_circle_filled" matTooltipClass="tooltip-inner right" [matTooltip]="createdBy" [matTooltipPosition]="'right'"></mat-icon>
        </div>
    </div>
</div>